/* eslint-disable import/prefer-default-export */
const convertToDatetime = (date) => {
  const splittedDate = date.split('/')
  return new Date(
    `${splittedDate[1]}-${splittedDate[0]}-${splittedDate[2]}`
  ).getTime()
}

export { convertToDatetime }
